import { generateUUId } from "@/views/businessManage/checkShop/util/ViewHelp";

export const IndicatorInfoHelp = {
  newItem() {
    return {
      key: generateUUId(),
      edit: true,
      instructions: "", //说明
      medalPicture: "", //勋章图片
      competitivePower: "", //竞争力
      sort: "", //排序
      liquidatedDamages: "", //违约金
      logisticsCompanyCode: "", //物流公司代码
      receivingNode: "", //收货节点
      minAmount:"", // 包邮最小金额
      maxAmount:"", // 包邮最大金额
    };
  },
};
